import React from "react";
import "./404.css";
// import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";

import placeholderImg from "../assets/images/new/fav-removebg-preview.png";
import { Link, Links } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="error-404">
      <div className="">
        <div>
          <img
            src={placeholderImg}
            alt="404 img"
            className="error-404__image"
          />
        </div>

        <h4 className="error-404__title">404</h4>
        <h3 className="error-404__text">Oops! Page Not Found </h3>
        <div className="error-404__btns">
          <Link
            to="/"
            className="Normal-app-btn"
            style={{ padding: "5px 16px", fontSize: "14px" }}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
